<section class="container AccountPageTemplate">
  <div class="row d-flex justify-content-center">
    @if (!formSubmitted) {
      <div class="contact-us col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <form (ngSubmit)="onSubmit()" [formGroup]="contactForm" class="cx-update-password-component">
          @if (hideData) {
            <div class="unregisterLog">
              <div class="form-group row">
                <div class="col-md-12">
                  <label>
                    <span class="label-content">Name*</span>
                    <input
                      aria-label="first name"
                      class="form-control"
                      type="text"
                      name="firstName"
                      placeholder="Enter first name"
                      formControlName="firstName"
                      />
                      <cx-form-errors [control]="contactForm.get('firstName')"></cx-form-errors>
                    </label>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <label>
                      <span class="label-content">Last name*</span>
                      <input
                        aria-label="Last name"
                        class="form-control"
                        type="text"
                        name="lastName"
                        placeholder="Enter last name"
                        formControlName="lastName"
                        />
                        <cx-form-errors [control]="contactForm.get('lastName')"></cx-form-errors>
                      </label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12">
                      <label>
                        <span class="label-content">Email*</span>
                        <input
                          aria-label="email"
                          class="form-control"
                          type="text"
                          name="email"
                          placeholder="Enter Email"
                          formControlName="email"
                          />
                          <cx-form-errors [control]="contactForm.get('email')"></cx-form-errors>
                        </label>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-12">
                        <label>
                          <span class="label-content">Business Name*</span>
                          <input
                            aria-label="company"
                            class="form-control"
                            name="Business Name"
                            placeholder=""
                            formControlName="company"
                            />
                            <cx-form-errors [control]="contactForm.get('company')"></cx-form-errors>
                          </label>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-12">
                          <label>
                            <span class="label-content">Essity Account Number*</span>
                            <input
                              aria-label="essityAccountno"
                              class="form-control"
                              name="essityAccountno"
                              placeholder=""
                              formControlName="essityAccount"
                              />
                              <cx-form-errors [control]="contactForm.get('essityAccount')"></cx-form-errors>
                            </label>
                          </div>
                        </div>
                      </div>
                    }
                    <!-- register User. -->
                    @if (showloggedin) {
                      <div>
                        <div class="form-group check">
                          <mat-form-field class="custom-mat-form-field" appearance="outline">
                            <mat-label>Enquiry Type*</mat-label>
                            <mat-select (selectionChange)="filterChangeRegister($event)" formControlName="enquiry">
                              @for (item of enquiryOptions; track item) {
                                <mat-option [value]="item">
                                  {{ item.value }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                          <cx-form-errors [control]="contactForm.get('enquiry')"></cx-form-errors>
                        </div>
                        @if (hideReason) {
                          <div class="form-group">
                            <mat-form-field class="custom-mat-form-field" appearance="outline">
                              <mat-label>Reason for Enquiry*</mat-label>
                              <mat-select (selectionChange)="lastfilterChangeRegister($event)" formControlName="reason">
                                @for (item of reasonOptionstest; track item) {
                                  <mat-option [value]="item">
                                    {{ item.value }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            <cx-form-errors [control]="contactForm.get('reason')"></cx-form-errors>
                          </div>
                        }
                      </div>
                    }
                    <!-- Unregister User. -->
                    @if (hideData) {
                      <div class="UnregisterUser">
                        <div class="form-group check">
                          <mat-form-field class="custom-mat-form-field" appearance="outline">
                            <mat-label>Enquiry Type *</mat-label>
                            <mat-select (selectionChange)="filterChangeUnregister($event)" formControlName="enquiry">
                              @for (item of enquiryOptions; track item) {
                                <mat-option [value]="item">
                                  {{ item.value }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                          <cx-form-errors [control]="contactForm.get('enquiry')"></cx-form-errors>
                        </div>
                        @if (hideReason) {
                          <div class="form-group">
                            <mat-form-field class="custom-mat-form-field" appearance="outline">
                              <mat-label>Reason for Enquiry*</mat-label>
                              <mat-select (selectionChange)="lastdropUnRegister($event)" formControlName="reason">
                                @for (item of reasonOptions; track item) {
                                  <mat-option [value]="item">
                                    {{ item.value }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            <cx-form-errors [control]="contactForm.get('reason')"></cx-form-errors>
                          </div>
                        }
                      </div>
                    }
                    <!-- field for Register User -->
                    @if (claimNo) {
                      <div class="form-group row">
                        <div class="col-12">
                          <label>
                            <span class="label-content">Claim Number </span>
                            <input
                              aria-label="Claim number"
                              class="form-control"
                              name="order"
                              placeholder=""
                              formControlName="claimNumber"
                              />
                              <cx-form-errors [control]="contactForm.get('claimNumber')"></cx-form-errors>
                            </label>
                          </div>
                        </div>
                      }
                      @if (agreement) {
                        <div class="form-group row">
                          <div class="col-12">
                            <label>
                              <span class="label-content">Agreement </span>
                              <input
                                aria-label="agreement"
                                class="form-control"
                                name="order"
                                placeholder=""
                                formControlName="agreemntNumber"
                                />
                                <cx-form-errors [control]="contactForm.get('agreemntNumber')"></cx-form-errors>
                              </label>
                            </div>
                          </div>
                        }
                        @if (folcredit) {
                          <div class="form-group row">
                            <div class="col-12">
                              <label>
                                <span class="label-content">Credit </span>
                                <input
                                  aria-label="folcredit"
                                  class="form-control"
                                  name="order"
                                  placeholder=""
                                  formControlName="folcredit"
                                  />
                                  <cx-form-errors [control]="contactForm.get('folcredit')"></cx-form-errors>
                                </label>
                              </div>
                            </div>
                          }
                          @if (folOrder) {
                            <div class="form-group row">
                              <div class="col-12">
                                <label>
                                  <span class="label-content">Order </span>
                                  <input
                                    aria-label="folOrder"
                                    class="form-control"
                                    name="order"
                                    placeholder=""
                                    formControlName="folOrder"
                                    />
                                    <cx-form-errors [control]="contactForm.get('folOrder')"></cx-form-errors>
                                  </label>
                                </div>
                              </div>
                            }
                            @if (poNumber) {
                              <div class="form-group row">
                                <div class="col-12">
                                  <label>
                                    <span class="label-content">PO Number </span>
                                    <input
                                      aria-label="poNumber"
                                      class="form-control"
                                      name="order"
                                      placeholder=""
                                      formControlName="poNumber"
                                      />
                                      <cx-form-errors [control]="contactForm.get('poNumber')"></cx-form-errors>
                                    </label>
                                  </div>
                                </div>
                              }
                              @if (Invoice) {
                                <div class="form-group row">
                                  <div class="col-12">
                                    <label>
                                      <span class="label-content">Invoice number </span>
                                      <input
                                        aria-label="phone"
                                        class="form-control"
                                        name="order"
                                        placeholder=""
                                        formControlName="invoiceNumber"
                                        />
                                        <cx-form-errors [control]="contactForm.get('invoiceNumber')"></cx-form-errors>
                                      </label>
                                    </div>
                                  </div>
                                }
                                @if (Order) {
                                  <div class="form-group row">
                                    <div class="col-12">
                                      <label>
                                        <span class="label-content">Order number </span>
                                        <input aria-label="phone" class="form-control" name="order" placeholder="" formControlName="Order" />
                                        <cx-form-errors [control]="contactForm.get('Order')"></cx-form-errors>
                                      </label>
                                    </div>
                                  </div>
                                }
                                <!-- end register user -->
                                <!-- <div class="form-group row" *ngIf="selectClaimcheckbox">
                                <input class="form-control" name="terms" formControlName="claimNoselect" class="form-check-input cx-np-checkbox"
                                  role="checkbox" type="checkbox" required /> Select Claim
                                </div> -->
                                <div class="form-group row">
                                  <div class="col-12">
                                    <label>
                                      <span class="label-content">Phone*</span>
                                      <input
                                        aria-label="phone"
                                        class="form-control"
                                        name="phone"
                                        placeholder="Enter phone"
                                        formControlName="phone"
                                        />
                                        <div class="phone-min-limit">
                                          {{ 'contactUs.minLength' | cxTranslate: { minLength: minPhoneNumberLength } }}
                                        </div>
                                        <cx-form-errors [control]="contactForm.get('phone')"></cx-form-errors>
                                      </label>
                                    </div>
                                  </div>
                                  <div class="form-group row">
                                    <div class="col-12">
                                      <label>
                                        <span class="label-content">Message*</span>
                                        <textarea
                                          class="form-control"
                                          type="text"
                                          name="message"
                                          placeholder="Enter message"
                                          formControlName="message"
                                        ></textarea>
                                        <cx-form-errors [control]="contactForm.get('message')"></cx-form-errors>
                                      </label>
                                    </div>
                                  </div>
                                  <div class="form-group row">
                                    <div class="col-12">
                                      <label class="label-content">
                                        <input
                                          class="form-control"
                                          name="terms"
                                          formControlName="terms"
                                          class="form-check-input cx-np-checkbox"
                                          role="checkbox"
                                          type="checkbox"
                                          required
                                          />
                                          <span class="form-check-label">
                                            This form asks for your contact details so we can respond to your inquiry via email. Have a look at our
                                            <a aria-label="terms of use" target="_blank" href="http://www.asaleocare.com/contact-us/terms-of-use/"
                                              >terms of use</a
                                              >
                                              and
                                              <a
                                                aria-label="privacy policy"
                                                target="_blank"
                                                href="https://www.asaleocare.com/contact-us/privacy-policy"
                                                >privacy policy</a
                                                >
                                                for a detailed description of how we protect and manage your submitted data.
                                              </span>
                                              <cx-form-errors [control]="contactForm.get('terms')"></cx-form-errors>
                                            </label>
                                          </div>
                                        </div>
                                        <div class="form-group row">
                                          <div class="col-12">
                                            <ngx-recaptcha2
                                              [siteKey]="siteKey"
                                              [useGlobalDomain]="false"
                                              (success)="onRecaptchaSuccess()"
                                              [useGlobalDomain]="false"
                                              size="normal"
                                              theme="light"
                                              formControlName="recaptcha"
                                              >
                                            </ngx-recaptcha2>
                                          </div>
                                        </div>
                                        <div class="form-group row">
                                          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                            <button class="btn btn-block btn-light" type="button" (click)="onCancel()">Clear</button>
                                          </div>
                                          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                            <button class="btn btn-block btn-primary" type="submit" [disabled]="disableForm">
                                              <i [ngClass]="{ 'fa-spinner fa-spin': spinner }" class="fa"></i>
                                              Submit
                                            </button>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  }
                                  @if (formSubmitted) {
                                    <div class="contact-us col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                      <h3 class="contact-us__reset-form-title">
                                        Thank you for your enquiry. One of our consultants will be in touch shortly.
                                      </h3>
                                      <div class="contact-us__reset-form-button col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                                        <button class="btn btn-block btn-primary" (click)="onFormRestartClicked()">Start a new message</button>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </section>
